import { WAC_CROSSFLOW_PARAMS } from '@townsquare/crossflow';
import { popularFeedResource } from '@townsquare/discover-view/popular-feed-resource';
import { homeHeaderViewResource } from '@townsquare/home-header/resources';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { homeTabRoute as homeTabRouteDefinition } from '@townsquare/routes/hometab-view';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';
import { workFeedSectionResource } from '@townsquare/work-feeds';

homeTabRouteDefinition.component = Loadable({
  loader: () => import(/* webpackChunkName: "hometab-view" */ './components/HomeTabView'),
  loading: () => null,
});
homeTabRouteDefinition.resources = [
  titanEapCrossFlowQueryResource,
  homeHeaderViewResource,
  workFeedSectionResource,
  onboardingResource,
  popularFeedResource,
];
homeTabRouteDefinition.query = [...WAC_CROSSFLOW_PARAMS.map(param => `${param}?`), 'src?', 'cloudId?'];
export const homeTabRoute = homeTabRouteDefinition;
